"use strict";function openApp$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.openApp$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.microApp.openApp";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.5.6"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.5.6"},_a)),exports.openApp$=openApp$,exports.default=openApp$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/microApp/openApp.js
// module id = 968
// module chunks = 106